import { ReactSVG } from "react-svg"
const columns = [
    {
        name: "Name",
        selector: (row) => row.name,
        sortable: true,
        maxWidth: "200px",
    },
    {
        name: "Email",
        selector: (row) => row.email,
        sortable: true,
        maxWidth: "200px",
    },
    {
        name: "Phone Number",
        selector: (row) => row.phone_number,
        sortable: true,
        maxWidth: "200px",
    },
    {
        name: "Height (in cm)",
        selector: (row) => row.height,
        sortable: true,
        maxWidth: "200px",
    },
    {
        name: "Weight (in kg)",
        selector: (row) => row.weight,
        sortable: true,
        maxWidth: "200px",
    },
    {
        name: "Age (in years)",
        selector: (row) => row.age,
        sortable: true,
        maxWidth: "200px",
    },
]

export default columns